import { useState, useCallback, useRef } from 'react';

export function useResizableColumns(initialWidths) {
  const [widths, setWidths] = useState(initialWidths);
  const widthsRef = useRef(widths);
  widthsRef.current = widths;

  const startResize = useCallback((colIndex, e) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = widthsRef.current[colIndex];

    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(40, startWidth + moveEvent.clientX - startX);
      setWidths(prev => {
        const next = [...prev];
        next[colIndex] = newWidth;
        return next;
      });
    };

    const onMouseUp = () => {
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }, []);

  const tableWidth = widths.reduce((a, b) => a + b, 0);

  return { widths, startResize, tableWidth };
}

export function ColGroup({ widths }) {
  return (
    <colgroup>
      {widths.map((w, i) => <col key={i} style={{ width: w }} />)}
    </colgroup>
  );
}

export function ResizeHandle({ onMouseDown }) {
  return (
    <div
      onMouseDown={onMouseDown}
      onMouseOver={e => { e.currentTarget.style.background = 'rgba(52,152,219,0.45)'; }}
      onMouseOut={e => { e.currentTarget.style.background = 'transparent'; }}
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '5px',
        cursor: 'col-resize',
        background: 'transparent',
        zIndex: 1,
      }}
    />
  );
}
